"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionPreviewPrefix = versionPreviewPrefix;
exports.versionPreviewKey = versionPreviewKey;
/** Storage prefix for one checkpoint's captured static preview. Capture writes
 * under it, the serve route reads under it, prune deletes under it — one
 * definition so the three can never drift apart. */
function versionPreviewPrefix(chatId, messageId) {
    return `${chatId}/v/${messageId}`;
}
function versionPreviewKey(chatId, messageId, assetPath) {
    return `${versionPreviewPrefix(chatId, messageId)}/${assetPath}`;
}
